import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bool, string, object } from "prop-types";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";

import Dailymotion from "react-dailymotion";
import YouTube from "react-youtube";
import assetify from "@quintype/framework/assetify";

import nhLogo from "../../basic/images/NH_logo.png";
import qaLogo from "../../basic/images/qaumi1.jpg";
import njLogo from "../../basic/images/NJ_logo.png";

import "./also-watch.m.css";

const getDmVideo = playListId => {
  return global.fetch(`https://api.dailymotion.com/playlist/${playListId}/videos?fields=embed_html,id,title`);
};

const DmPlayer = ({ playListId }) => {
  const [videoId, setVideoId] = useState();

  useEffect(() => {
    getDmVideo(playListId)
      .then(res => res.json())
      .then(playList => setVideoId(get(playList, ["list", "0", "id"], null)));
  }, []);

  return (
    <div styleName="player">
      {videoId && <Dailymotion video={videoId} autoplay autoplayQueue showQueue syndication="273869" mute />}
    </div>
  );
};

DmPlayer.propTypes = {
  playListId: string
};

const YoutubePlayer = ({ playListId }) => {
  const options = {
    playerVars: {
      autoplay: 1,
      mute: 1,
      listType: "playlist",
      list: playListId
    }
  };

  const onReady = e => {
    e.target.playVideo();
  };

  return (
    <div styleName="player">
      <YouTube opts={options} onReady={onReady} />;
    </div>
  );
};

YoutubePlayer.propTypes = {
  playListId: string
};

const getLogo = lang => {
  switch (lang) {
    case "ur":
      return qaLogo;
    case "hi":
      return njLogo;
    default:
      return nhLogo;
  }
};

const AlsoWatch = ({ enabled, type, alsoWatch, lang }) => {
  if (!enabled) return null;

  const Player = type === "youtube" ? YoutubePlayer : DmPlayer;
  const playListId = alsoWatch[type].playlist_id;

  return (
    <WithLazy margin="300px">
      {() => (
        <div styleName="wrapper">
          <h4 styleName="logo-wrapper">
            <img styleName="logo" src={`${assetify(getLogo(lang))}`} /> Also Watch
          </h4>
          <Player playListId={playListId} />
        </div>
      )}
    </WithLazy>
  );
};

AlsoWatch.propTypes = {
  enabled: bool,
  lang: string,
  type: string,
  alsoWatch: object
};

const mapStateToProps = state => {
  const publisherAttributes = get(state, ["qt", "config", "publisher-attributes"]);
  const item = publisherAttributes.alsoWatch;

  return {
    enabled: item.enabled,
    type: item.type,
    alsoWatch: item,
    lang: publisherAttributes.lang
  };
};

export default connect(
  mapStateToProps,
  null
)(AlsoWatch);
